import React, { useEffect, useState } from "react";
import { isExpired, decodeToken } from "react-jwt";
import styles from './WaterMark.module.css';
import moment from 'moment';
function WaterMark1() {
  const [user_data, setUserData] = useState({});
  // const { decodedToken, isExpired } = useJwt();
  useEffect(() => {
    if (sessionStorage.getItem("user") != "" && sessionStorage.getItem("user") != null) {
      const token = JSON.parse(sessionStorage.user);
      // const token =decodeToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImJpcGlucy50dGwiLCJpcF9hZGRyZXNzIjoiMTE1LjExMy4xNzQuMTAyIiwibG9naW5fdGltZSI6IjItMTAtMjAyMyAxNDoxNzoyMiIsInVzZXJfbG9nIjozOTQsImlhdCI6MTY3NjAzODY0Mn0.MIhtxz9eGhD5eqzxXhB6HbR3w0YVU2oKQq5W0e-iwi0")
      // const token =JSON.parse(sessionStorage.user);

      // local code
      // setUserData(token);
      // Dev code and prod
      const myDecodedToken = decodeToken(token.token);
      setUserData(myDecodedToken);
    }
  }, [])

  return (
    <>

      <div className={styles.watermark}>
        <p className={styles.watermark_p}>{user_data.username}</p>
        <p className={styles.watermark_p}>{user_data.ip_address}</p>
        {/* <p className={styles.watermark_p}>{moment(new Date(user_data.login_time)).subtract(390, 'minute').format("M-DD-YYYY HH:mm:ss")}</p> */}
        <p className={styles.watermark_p}>{moment(new Date(user_data.login_time)).add(330, 'minute').format("M-DD-YYYY HH:mm:ss")}</p>
      </div>
    </>

  );
}

export default WaterMark1;